import { Col, Form, Modal, Row, Select, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import { useEffect, useState } from 'react';

import styled from 'styled-components';
import { styledTable } from '../styled/mixin';

const StyledDiv = styled.div`
  ${styledTable}
`;
const { Text } = Typography;
const { Option } = Select;

interface ImportTaxInvoiceModalProps {
  handleOk: (year: string, quarter: string) => void;
  handleCancel: () => void;
  isOpen: boolean;
  confirmLoading: boolean;
  modalText: string;
}

function ImportTaxInvoiceModal({
  handleOk,
  handleCancel,
  isOpen,
  confirmLoading,
  modalText,
}: ImportTaxInvoiceModalProps) {
  const [form] = Form.useForm();
  dayjs.extend(quarterOfYear);
  const [year, setYear] = useState(dayjs().year().toString());
  const [quarter, setQuarter] = useState(dayjs().quarter().toString());

  useEffect(() => {
    form.resetFields();
  }, [form, isOpen]);

  return (
    <StyledDiv>
      <Modal
        title="매입증빙 불러오기"
        open={isOpen}
        forceRender={true}
        onOk={() => {
          handleOk(year, quarter);
        }}
        confirmLoading={confirmLoading}
        onCancel={handleCancel}
      >
        <Row>
          <Col>
            <Text>{modalText}</Text>
          </Col>
        </Row>
        <Row style={{ marginTop: '20px' }}>
          <Form
            form={form}
            layout="inline"
            size="small"
            initialValues={{ year, quarter }}
          >
            <Space>
              <Col span={10}>
                <Form.Item name="year">
                  <Select
                    style={{ width: '150px' }}
                    onSelect={async (key: any, option: any) => {
                      setYear(key);
                    }}
                  >
                    <Option value="2025">2025년</Option>
                    <Option value="2024">2024년</Option>
                    <Option value="2023">2023년</Option>
                    <Option value="2022">2022년</Option>
                    <Option value="2021">2021년</Option>
                    <Option value="2020">2020년</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item name="quarter">
                  <Select
                    style={{ width: '150px' }}
                    onSelect={async (key: any, option: any) => {
                      setQuarter(key);
                    }}
                  >
                    <Option value="1">1분기</Option>
                    <Option value="2">2분기</Option>
                    <Option value="3">3분기</Option>
                    <Option value="4">4분기</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Space>
          </Form>
        </Row>
      </Modal>
    </StyledDiv>
  );
}

export default ImportTaxInvoiceModal;
